// export const API_URL = 'http://localhost/bonian/'
// export const API_URL = 'https://btlbd.tk/bonian-admin/'
export const API_URL = 'https://bonianbd.com/bonian-admin/'
